import StyledDropdown from 'components/Elements/StyledDropdown'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { matchPath, useLocation } from 'react-router-dom'
import { langs } from 'services'
import { HELP_DESK, HELP_EMAILS } from 'services/constants'
import { FooterContainer } from './style'

function Footer() {
  const { t, i18n } = useTranslation()
  const { pathname } = useLocation()
  const { lang, setLang } = useContext(DataContext)

  const changeLang = (ln) => {
    i18n.changeLanguage(ln)
    setLang(ln)
    localStorage.setItem('locale', ln)
  }

  const match = matchPath(pathname, {
    path: `/dashboard`,
  })

  return (
    !match && (
      <FooterContainer className="w-100">
        <Row>
          <Col md={3} xs={{ span: 12 }}>
            <div className="footer-col">
              <h4>{t('contact')}</h4>
              <a
                href={HELP_DESK['main'][lang]}
                target="_blank"
                rel="noreferrer"
              >
                {t('help_center')}
              </a>
              <a href={`mailto:${HELP_EMAILS['main'][lang]}`}>
                {HELP_EMAILS['main'][lang]}
              </a>
            </div>
          </Col>
          <Col md={3} xs={{ span: 12 }}>
            <div className="footer-col">
              <h4>{t('about_us')}</h4>
              <a href="/about-us">{t('our_story')}</a>
            </div>
          </Col>
          <Col md={3} xs={{ span: 12 }}>
            <div className="footer-col">
              <h4>{t('our_service')}</h4>
              <a href="/">{t('home')}</a>
              <a href="/your-book">{t('yourbook')}</a>
              <a href="/how-it-works">{t('howitworks')}</a>
              <a href="/pricing">{t('pricing')}</a>
              <a href="/get-started">{t('getstarted')}</a>
            </div>
          </Col>
          <Col md={3} xs={{ span: 12 }}>
            <div className="footer-col">
              <h4>{t('your_country')}</h4>
              <StyledDropdown
                className="lang-selector"
                options={langs}
                defaultValueId={lang}
                onChange={(option) => changeLang(option.id)}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="footer-bottom">
              <a href="/terms">{t('terms_and_conditions')}</a>
              <a href="/privacy">{t('privacy_policy')}</a>
              <a href="/imprint">{t('imprint')}</a>
            </div>
          </Col>
        </Row>
      </FooterContainer>
    )
  )
}

export default Footer
